const localConfig = {
  MIXPANEL_KEY: '',
};

export default localConfig;
